'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { createComponent } from '../core/create-component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    /**
   * Should it be disabled or not
   */ disabled: PropTypes.bool,
    /**
   * Button type
   */ variant: PropTypes.oneOf([
        'previous',
        'next'
    ]),
    /**
   * Provide the text that should be used for screen readers.
   */ accessibleText: PropTypes.string
};
/**
 * @subcomponent Pagination
 */ const PaginationButton = createComponent({
    displayName: 'PaginationButton',
    root: 'a',
    propTypes,
    propConfig: {
        derivedProps (props) {
            const { as, component, disabled } = props;
            return {
                as: disabled && 'span' || as || component || 'a'
            };
        },
        processProps (_param, _param1) {
            var { accessibleText } = _param, props = _object_without_properties(_param, [
                "accessibleText"
            ]), { as } = _param1;
            return _object_spread_props(_object_spread({
                'aria-label': accessibleText !== null && accessibleText !== void 0 ? accessibleText : undefined
            }, props), {
                as,
                role: 'button'
            });
        },
        classNames (props, derivedProps) {
            const { disabled, variant } = props;
            const classNameSet = new Set([
                `swan-pagination-button-${variant}`
            ]);
            if (disabled && derivedProps.as === 'span') classNameSet.add('swan-pagination-button-disabled');
            return classNameSet;
        },
        wrapChildren (props) {
            switch(props.variant){
                case 'next':
                    return /*#__PURE__*/ React.createElement(Icon, {
                        iconType: "chevronRight"
                    });
                case 'previous':
                    return /*#__PURE__*/ React.createElement(Icon, {
                        iconType: "chevronLeft"
                    });
                default:
                    return /*#__PURE__*/ React.createElement(React.Fragment, null);
            }
        }
    }
});

export { PaginationButton };
